import React, {createContext, useContext} from 'react';

export type SweepsContextType = {
  isSweeps: boolean;
};

/**
 * This will return whenever the context is accessed outside the provider. We're using this behavior to easily detect when we're in the sweeps domain
 */
const defaultContext: SweepsContextType = {
  isSweeps: false,
};
export const SweepsContext = createContext<SweepsContextType>(defaultContext);

export const SweepsProvider = ({children}: {children: React.ReactNode}) => {
  return (
    <SweepsContext.Provider value={defaultContext}>
      {children}
    </SweepsContext.Provider>
  );
};

export const useSweepsContext = () => {
  return useContext(SweepsContext);
};
